import { RewardType } from 'kuaidong-model'

export enum LotteryType {
  One = 'type_one',
  Five = 'type_five',
}

export enum LotteryGlobalAction {
  Purchase = 'purchase',
}

export interface ILotteryResult {
  reward_list: Array<{
    stage_id: string
    trans_flag: boolean
    member_pop?: boolean
    trans_coin?: boolean
    trans_count?: number
  }>
  not_enough_money: boolean
}

export interface ILotteryReward {
  time: string
  stage_id: string
  trans_flag: boolean
  trans_coin?: boolean
  reward_type: RewardType
}

export interface ILotteryBarrageItem {
  avatar: string
  stage_id: string
  nick_name: string
}
